var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKids = function SvgKids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7.868V6a3 3 0 016 0v1h.5V6a3 3 0 116 0v1.905l2.482 12.906a1 1 0 11-1.964.378l-.517-2.689h-3.439l.422 2.321a1 1 0 11-1.968.358l-1.22-6.715-1.825 6.775a.992.992 0 01-.31.512A.996.996 0 0111 22H2a1 1 0 110-2h2.234L7.5 7.868zM9.5 6a1 1 0 012 0v1h-2V6zM6.305 20h3.929l2.961-11H9.266L6.305 20zm12.829-6.009l.482 2.509h-3.418l-.454-2.5H19c.045 0 .09-.003.134-.009zM15.38 12h3.37l-.576-3h-2.908l-.257.957L15.38 12zM18 7V6a1 1 0 10-2 0v1h2z"
  })));
};
export default SvgKids;